import React from 'react'

const PermCheckIcon = () => {
    return (
        <svg className='perm-check-icon' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500.01 500.01">
            <circle cx="250" cy="250" r="235" />
            <path d="M104.84,265.39l92.78,95.26,193.75-191.91" />
        </svg>
    )
}

export default PermCheckIcon
